import { RegularButtonWrapper } from '@monthio/react-components'
import styled from 'styled-components'

export const BackButtonContainer = styled(RegularButtonWrapper)`
	display: flex;
	align-items: center;
	justify-content: center;
`

export const ButtonWrapper = styled(RegularButtonWrapper)`
	max-width: 250px;
	margin: auto;
`

export const SnnTextInputFieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	margin-bottom: 15px;
`
